import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@app/store/utils/baseQueryWithReauth';
import { MatrixResponse } from '@app/store/slices/matrix/matrixTypes';

export const matrixApi = createApi({
  reducerPath: 'matrixApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getMatrixTree: builder.query<MatrixResponse | null, { playground_id: number }>({
      query: (params) => ({
        url: '/matrix/ternar-tree',
        params,
      }),
    }),
  }),
});

export const { useGetMatrixTreeQuery } = matrixApi;
